// Mobile Play tab content — title screen aesthetic with play submenu

import { css, html } from 'lit';
import { BaseComponent } from '../../lib/base-component.js';
import { router } from '../../lib/router.js';

class MobilePlayTab extends BaseComponent {
  static styles = css`
    :host {
      display: block;
      width: 100%;
      height: 100%;
    }

    .play-screen {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      padding: 0 1rem 2rem;
      background: center center / cover no-repeat;
      position: relative;
      overflow: hidden;
    }

    .play-screen::before {
      content: '';
      position: absolute;
      inset: 0;
      background: rgba(0, 0, 0, 0.45);
      pointer-events: none;
    }

    .content {
      z-index: 1;
      text-align: center;
    }

    .game-title {
      font-family: 'MedievalSharp', Georgia, serif;
      font-size: 3rem;
      font-weight: 700;
      color: #ffffff;
      margin: 0 0 0.25rem 0;
      letter-spacing: 0.15em;
      text-shadow:
        0 0 8px rgba(0, 0, 0, 1),
        0 0 20px rgba(0, 0, 0, 0.9),
        0 0 40px rgba(0, 0, 0, 0.7),
        0 2px 4px rgba(0, 0, 0, 1);
    }

    .tagline {
      font-size: 0.85rem;
      color: rgba(255, 255, 255, 0.85);
      margin: 0 0 2.5rem 0;
      letter-spacing: 0.2em;
      text-transform: uppercase;
      font-weight: 300;
      text-shadow:
        0 0 6px rgba(0, 0, 0, 1),
        0 0 16px rgba(0, 0, 0, 0.8);
    }

    .menu {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.5rem;
    }

    .menu-btn {
      display: block;
      width: 280px;
      padding: 0.85rem 1.5rem;
      font-size: 1.1rem;
      font-family: 'MedievalSharp', Georgia, serif;
      letter-spacing: 0.12em;
      color: rgba(255, 255, 255, 0.9);
      background: rgba(0, 0, 0, 0.55);
      border: 1px solid rgba(255, 255, 255, 0.2);
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.2s ease;
      text-align: center;
      backdrop-filter: blur(4px);
      -webkit-tap-highlight-color: transparent;
    }

    .menu-btn:active {
      background: rgba(0, 0, 0, 0.7);
      transform: scale(0.98);
    }

    .menu-btn.disabled {
      color: rgba(255, 255, 255, 0.3);
      border-color: rgba(255, 255, 255, 0.1);
      cursor: not-allowed;
      background: rgba(0, 0, 0, 0.35);
    }
  `;

  /** @param {string} href */
  _navigate(href) {
    router.navigate(href);
  }

  render() {
    return html`
      <div
        class="play-screen"
        style="background-image: url('${process.env.PUBLIC_CDN_BASE_URL}/title-screen/adventurers-at-the-barrow')"
      >
        <div class="content">
          <h1 class="game-title">RPGish</h1>
          <p class="tagline">Automated GM-Less 5e Adventures</p>
          <nav class="menu">
            <button class="menu-btn" @click="${() => this._navigate('/campaign')}">Campaign</button>
            <button class="menu-btn" @click="${() => this._navigate('/play/adventures')}">Adventures</button>
            <button class="menu-btn" @click="${() => this._navigate('/survival')}">Dungeon Survival</button>
          </nav>
        </div>
      </div>
    `;
  }
}

customElements.define('mobile-play-tab', MobilePlayTab);
